import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from '../../axios-local-api';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import classes from './ClaimPod.css';


class ClaimPod extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClaimPod = this.handleClaimPod.bind(this);
  }

  handleClaimPod() {
    this.props.onSuccess();
  }

  confirmModalCancelHandler = () => {
    this.props.onCancel();
  };

  render() {
    return (
      <div>
        <span
          id="ReclaimCancel"
          onClick={this.confirmModalCancelHandler}
          style={{ float: 'right', color: 'gray', cursor: 'pointer' }}
        >
          X
        </span>
        <div className={classes.ClaimPod}>
          <h3>{this.props.podTitle}</h3>
          <div style={{ margin: '30px 0x 0px 30px' }}>
            <p className={classes.Content}>{this.props.podMessage} </p>
            <button
              id="podReclaimOKBtn"
              className={classes.SaveBtn}
              btnType="Success"
              onClick={this.handleClaimPod}
            >
              {this.props.podBtnText}{' '}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(ClaimPod, axios));


